<template>
    <div class="fm-internal">
        <Backer />
        <div style="width: 90%; max-width: 1024px; margin-left: auto; margin-right: auto;">
            <div class="di10px"><h3>{{params.title}}</h3></div>
            <div>
                <div class="di10px">
                    <div>
                        Select Location
                    </div>
                    <b-form-select 
                        size="sm" 
                        v-model="location_id" 
                        :options="packet.locations" 
                        v-on:change="fetch_init"
                        style="width: 200px; margin-top: 10px;">    
                    </b-form-select>
                </div>
            </div>

            <div>
                <b-overlay
                    id="overlay-background"
                    :show="items_being_loaded"
                    variant="white"
                    opacity="0.85"
                    blur="1rem"
                    rounded="sm"
                >
                    <div v-if="items.length > 0">
                        <div>Items</div>
                        <div v-for="item,idx in items_to_show" style="margin-top: 2px; width: 100%; margin-left: auto; margin-right: auto;" v-bind:key="id"> 
                            <TRTemplateA :viewdata="{item: item, idx: idx, packet: packet, global_vars: global_vars}" />
                        </div>
                    </div>
                    <div v-else-if="location_id != null && items.length <= 0">No Items to show</div>
                </b-overlay>
            </div>
        </div>

        <div style="height: 150px;">
            <!--empty div to create padding on the bottom-->
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import TRTemplateA from "@/components/importables/TRTemplateA"

    export default {
        name: "TRItemsListV1",
        props: ["viewdata"],
        components: {Backer, TRTemplateA},
        data: function(){
            return {
                userDetails: {properties: {}},
                items: [],
                items_to_show: [],
                items_being_loaded: false,
                packet: {},
                all_loc_inventory_dict: {},
                global_vars: global_vars,
                location_id: null,
                params: {}
            }
        },
        methods: {
            fetch_init: function(){
                let that = this;
                let path = this.params.data_api_path;
                let data = this.configure_params(this.params.data_api_params);
                console.log(data, 'uyes')
                let s = function(response){
                    if (response.data.result){
                        
                        that.items = response.data.result;
                        that.items_to_show = JSON.parse(JSON.stringify(that.items));
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error, 
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                };

                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading open transfers.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                that.items_being_loaded = true;
                this.items = [];
                Requestor.postSyncP(path, data, this, s, f);
            },
            fetch_prereqs: function(){
                // pull availability numbers
                let that = this;
                let prereqs = [
                    {
                        path:  "/api/inventory/get_all_loc_inventory_dict/",
                        data: {},
                        type: "",
                        executable: Requestor.getSync,
                        s: function(response){
                            if (response.data.result){
                                that.packet.all_loc_inventory_dict = response.data.result;
                                //that.fetch_init()
                            }
                            else {
                                that.$bvToast.toast(
                                    response.data.error, 
                                    {title: "Error", autoHideDelay: 1500, variant:"warning"}
                                );
                            }
                        },
                        f: function(error){
                            console.log(error)
                            that.$bvToast.toast(
                                "Error loading inventory.",
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }
                ]

                for (var i=0; i<prereqs.length; i++) {
                    let path = prereqs[i]["path"];
                    let data = prereqs[i]["data"];
                    let s = prereqs[i]["s"];
                    let f = prereqs[i]["f"];
                    let type = prereqs[i]["type"];
                    if (type == "secure"){
                        prereqs[i]["executable"](path, data, this, s, f);   
                    }
                    else {
                        prereqs[i]["executable"](path, data, s, f); 
                    }
                }
            },
            configure_params: function(data){
                data.userid = this.packet.userDetails.id;
                data.userrole = this.packet.userDetails.userrole;

                if (data.name == "ShippingCustomerPickup"){
                    data.source_location_id = this.location_id;
                }
                else if (data.name == "ShippingItemsShipped"){
                    data.source_location_id = this.location_id;
                }
                else {
                   data.location_id = this.location_id; 
                }
                return data
            }
        },
        created: function(){
            this.packet = this.viewdata.packet;
            this.params = this.viewdata.params;
            this.fetch_prereqs()
        }

    }
</script>

<style scoped>
    td {
        padding: 3px;
        background: inherit;
        font-size: 14px;
    }
</style>


// WEBPACK FOOTER //
// src/components/importables/TRItemsListV1.vue